export function sortProjectsByRecency<T extends { updatedAt: number }>(
	projects: Array<T>,
): Array<T> {
	return [...projects].sort((a, b) => b.updatedAt - a.updatedAt)
}
